const homeAdmin = {
  mainTitleHomeAdmin: 'Cập nhật dữ liệu về tình trạng giao thông trong Tp. Hồ Chí Minh',
  PositionChooseAdminMap: 'Chọn vị trí cụ thể trên bản đồ nơi muốn cập nhật dữ liệu',
  subtitleStatus: 'Thông tin về tình trạng giao thông',
  currentVelocity: 'Tốc độ hiện tại',
  effectiveTime: 'Khoảng thời gian hiệu lực',
  description: 'Mô tả',
  reason: 'Nguyên nhân',
  reasonLabel: 'Nguyên nhân',
  weather: 'Thời tiết',
  weatherLabel: 'Thời tiết',
  unitEffectiveTime: 'phút',
  titleUpdateButton: 'Cập nhật tình trạng giao thông',
  trafficJam: 'Tắc đường',
  flooding: 'Lũ lụt',
  obstacle: 'Vật cản',
  accident: 'Tai nạn',
  police: 'Công an',
  forbiddenRoad: 'Đường cấm',
  blankWeather: '--',
  clearSky: 'Trời đẹp',
  scatteredClouds: 'Nhiều mây',
  brokenClouds: 'Nhiều mây đen',
  lightRain: 'Mưa nhỏ',
  heavyRain: 'Mưa lớn',
  mist: 'Sương mù',
  ViewTrafficStatusButtonAdmin: 'Xem tình trạng giao thông',
  UpdateTrafficStatusButtonAdmin: 'Cập nhật tình trạng giao thông',
  ViewTrafficStatusTutorialAdmin: `Với chế độ "XEM TÌNH TRẠNG GIAO THÔNG" bạn có thể xem tình trạng giao thông trên bản đồ nhưng không thể cập nhật tình trạng giao thông.`,
  UpdateTrafficStatusTutorialAdmin: `Với chế độ "CẬP NHẬT TÌNH TRẠNG GIAO THÔNG" bạn không thể xem tình trạng giao thông trên bản đồ nhưng bạn có thể cập nhật tình trạng giao thông.`,
  NotFoundRoadError: `Không thể tìm đường giữa hai điểm này`,
  SpeechReport: 'Giọng Nói',
  FormReport: 'Biểu Mẫu',
  notification:`Thông báo`,
  close:`Đóng`,
  healthFacilityName: `Tên cơ sở y tế`,
  address: `Địa chỉ`,
  workTime: `Thời gian làm việc`,
  specialisation: `Chuyên khoa`,
  service: `Dịch vụ`,
  phoneNumber: `Số điện thoại`,
  license: `Giấy phép hoạt động`,
  accept: `Chấp nhận`,
  reject: `Từ chối`
}

export default homeAdmin;
